export default __webpack_public_path__ + "static/contact-5b539e6998b10567cee7565d27d953a4.png";